var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.725 25c.48 0 .863-.194 1.195-.555l9.452-10.385c.418-.472.616-.957.628-1.553 0-.596-.197-1.095-.628-1.553L2.92.554C2.588.195 2.193 0 1.725 0 .764 0 0 .86 0 1.927c0 .527.197 1.026.542 1.415l8.38 9.165-8.38 9.151A2.127 2.127 0 000 23.073C0 24.14.764 25 1.725 25z",
    fill: "#FFA700"
  })));
}
export default SvgBigArrow;